import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    acceptStuts: '1',
    // 全局状态机制
    isCollapse: false,
    userInfo: {},
    headerTitle: '',
  },
  getters: {
    isCollapse(state) {
      return state.isCollapse
    },
    getUserInfo(state) {
      return state.userInfo
    },
    getHeaderTitle(state) {
      return state.headerTitle
    }
  },
  mutations: {
    changeIsCollapse(state, payload) {
      state.isCollapse = payload.isCollapse
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setHeaderTitle(state, title) {
      state.headerTitle = title
    }
  },
  actions: {
    changeUserInfo(context,userInfo){
      context.commit('setUserInfo',userInfo)
    },
    changeRouterTitle(context,title){
      context.commit('setHeaderTitle',title)
    }
  }
});


